import React, { HTMLAttributes } from "react";
import PropTypes from "prop-types";
import cn from "classnames";

interface IDialogTitleProps extends HTMLAttributes<HTMLDivElement> {
  dialogPrefix?: string;
}

interface IDialogTitleStates extends HTMLAttributes<HTMLDivElement> {}

class DialogBody extends React.Component<
  IDialogTitleProps,
  IDialogTitleStates
> {
  static propTypes: PropTypes.InferProps<IDialogTitleProps>;

  /**
   * default property values
   *
   * @static
   * @memberof Viewport
   */
  static defaultProps = {};

  constructor(props:any) {
    super(props);
    this.state = {};
  }

  private defaultDialogPrefix = "modal";

  render() {
    const { dialogPrefix, children, className, ...props } = this.props;
    const prefix = dialogPrefix || this.defaultDialogPrefix;
    //const headerClassName = cn(className, prefix + "-content");
    const headerClassName = cn(className, prefix + "-body");

    return (
      <div {...props} className={headerClassName}>
        {children}
      </div>
    );
  }
}

export default DialogBody;
